import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { snoozeSiteMap } from './siteMapFlags';
import { PostHogEventEnum } from '@/Domain/enum/PostHogEvent.enum';
import { usePostHogAnalytics } from '@/Domain/hooks/App/usePostHog/usePostHogAnalytics.hook';

interface SnoozeContext {
  source: 'dock' | 'modal';
  totalUrls: number;
  onKnowledgeBase: boolean;
}

// "Not now" on a ready map, shared by the dock's X and the review's Cancel/Esc/overlay.
export const useSnoozeSiteMap = () => {
  const { t } = useTranslation(['knowledge_base']);
  const { capture } = usePostHogAnalytics();

  return (mapKey: string, { source, totalUrls, onKnowledgeBase }: SnoozeContext) => {
    snoozeSiteMap(mapKey);
    capture(PostHogEventEnum.SiteScrapeSnoozed, {
      source,
      total_urls: totalUrls,
      on_knowledge_base: onKnowledgeBase,
    });
    toast.success(t('tabs.website.review.snooze_toast'));
  };
};
